import { Link } from "react-router-dom";

const PLANS = [
  { name: "Starter", price: 19, credits: 50, features: ["50 AI generations/month", "Text & Image generation", "Basic templates", "Email support"] },
  { name: "Pro", price: 49, credits: 200, features: ["200 AI generations/month", "All content types", "Advanced templates", "Priority support", "Brand voice settings"], popular: true },
  { name: "Business", price: 149, credits: 1000, features: ["1000 AI generations/month", "Unlimited templates", "Custom brand voice", "API access", "Dedicated support"] },
];

export function PricingSection() {
  return (
    <section id="pricing" className="py-24 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#0066FF] mb-4 text-center">Pricing</p>
        <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-center mb-4">Simple, Transparent Pricing</h2>
        <p className="text-gray-600 text-center mb-16 max-w-2xl mx-auto">
          Start free with 10 credits. Upgrade anytime for more power.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={`border-2 ${plan.popular ? "border-[#0066FF]" : "border-black"} p-8 relative ${
                plan.popular ? "shadow-[8px_8px_0px_0px_rgba(0,47,167,1)]" : ""
              }`}
              data-testid={`pricing-${plan.name.toLowerCase()}`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#0066FF] text-white px-4 py-1 text-xs font-bold">
                  MOST POPULAR
                </div>
              )}
              <h3 className="text-xl font-bold mb-2">{plan.name}</h3>
              <div className="mb-6">
                <span className="text-4xl font-black">${plan.price}</span>
                <span className="text-gray-500">/month</span>
              </div>
              <ul className="space-y-3 mb-8">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2">
                    <span className="text-[#0066FF] font-bold">+</span>
                    <span className="text-sm">{f}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/register"
                className={`block text-center py-3 font-bold transition-all ${
                  plan.popular ? "bg-[#0066FF] text-white hover:bg-[#0052CC]" : "border border-black hover:bg-black hover:text-white"
                }`}
                data-testid={`pricing-cta-${plan.name.toLowerCase()}`}
              >
                Get Started
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
